exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".description-dot{display:inline-block;width:1em;height:1em;border-radius:50%}", ""]);

